<template>
  <div
    class="vl-calendar"
    :class="[
      availableplan
        ? 'vl-calendar__availableplan'
        : 'vl-calendar__' + changeDate,
    ]"
  >
    <div class="vl-calendar__title" v-if="!availableplan">
      {{ langTranslate("dayof", lang) }}
      <span v-if="changeDate == 'start'">
        {{ langTranslate("pickup", lang) }}</span
      ><span v-else> {{ langTranslate("delivery", lang) }}</span
      >:
    </div>
    <span
      class="vl-calendar__arrow vl-calendar__arrow--back"
      @click="moveBack()"
      v-if="
        !availableplan &&
          (current >= -(maxMonthStart - 1) ||
            currentMonthMonth > todayMonthMonth ||
            currentMonthYear > todayMonthYear)
      "
    />
    <span
      class="vl-calendar__arrow vl-calendar__arrow--back"
      @click="moveBack()"
      v-else-if="availableplan && current >= -(maxMonthStart - 1)"
    />
    <span class="vl-calendar__arrow vl-calendar__arrow--back disabled" v-else />

    <span
      class="vl-calendar__arrow vl-calendar__arrow--forward"
      @click="moveForward()"
      v-if="current <= maxMonthEnd - 2 && !singleMonth"
    />
    <span
      class="vl-calendar__arrow vl-calendar__arrow--forward"
      @click="moveForward()"
      v-else-if="current <= maxMonthEnd - 1 && singleMonth"
    />
    <span
      class="vl-calendar__arrow vl-calendar__arrow--forward disabled"
      v-else
    />
    <vl-calendar-month
      class="vl-calendar__month"
      :month="currentMonthMonth"
      :year="currentMonthYear"
      :is-selected="isSelected"
      :is-disabled="isDisabled"
      :is-occupied="isOccupied"
      :is-partially="isPartially"
      :custom-classes="customClasses"
      :show-weeks-number="showWeeksNumber"
      :first-day-of-week="firstDayOfWeek"
      :selected-date="selectedDate"
      :is-hovering="isHovering"
      :maxDate="maxDate"
      :lang="lang"
      @input="(date) => $emit('input', date)"
      @update:hovering="
        (state) => {
          if (!availableplan) {
            isHovering = state;
          }
        }
      "
    />

    <vl-calendar-month
      v-if="!singleMonth"
      class="vl-calendar__month"
      :month="nextMonthMonth"
      :year="nextMonthYear"
      :is-selected="isSelected"
      :is-disabled="isDisabled"
      :is-occupied="isOccupied"
      :is-partially="isPartially"
      :custom-classes="customClasses"
      :show-weeks-number="showWeeksNumber"
      :first-day-of-week="firstDayOfWeek"
      :selected-date="selectedDate"
      :is-hovering="isHovering"
      :maxDate="maxDate"
      :lang="lang"
      @input="(date) => $emit('input', date)"
      @update:hovering="
        (state) => {
          if (!availableplan) {
            isHovering = state;
          }
        }
      "
    />
  </div>
</template>

<script>
import VlCalendarMonth from "./vl-calendar-month";
import * as DatesUtils from "@/utils/DatesUtils";
import { DAYS_SHORTCUTS } from "@/constants/days";
import { langTranslate } from "@/constants/days";

export default {
  name: "VlCalendar",
  components: {
    VlCalendarMonth,
  },
  emits: ["input"],
  props: {
    isSelected: Function,
    isDisabled: Function,
    isOccupied: Function,
    isPartially: Function,
    customClasses: Object,
    showWeeksNumber: Boolean,
    singleMonth: Boolean,
    defaultDate: String,
    selectedDate: Object,
    changeDate: String,
    maxDate: String,
    firstDayOfWeek: {
      type: String,
      validator: (v) => DAYS_SHORTCUTS.includes(v),
      default: "mon",
    },
    maxMonthStart: { required: false, default: 2 },
    maxMonthEnd: { required: false, default: 2 },
    availableplan: { required: false, default: false },
    lang: { required: false, default: "DE" },
  },

  data() {
    const defaultDate = this.defaultDate
      ? DatesUtils.parseDate(this.defaultDate)
      : DatesUtils.getToday();
    return {
      currentMonthMonth: defaultDate.getMonth(),
      todayMonthMonth: DatesUtils.getToday().getMonth(),
      currentMonthYear: defaultDate.getFullYear(),
      todayMonthYear: DatesUtils.getToday().getFullYear(),
      current: 0,
      isHovering: false,
    };
  },
  setup() {
    return {
      langTranslate,
    };
  },
  computed: {
    nextMonthMonth() {
      return this.currentMonthMonth === 11 ? 0 : this.currentMonthMonth + 1;
    },

    nextMonthYear() {
      return this.currentMonthMonth === 11
        ? this.currentMonthYear + 1
        : this.currentMonthYear;
    },
  },

  methods: {
    moveBack() {
      this.current--;
      if (this.currentMonthMonth === 0) {
        this.currentMonthMonth = 11;
        this.currentMonthYear--;
      } else {
        this.currentMonthMonth--;
      }
    },

    moveForward() {
      this.current++;
      if (this.currentMonthMonth === 11) {
        this.currentMonthMonth = 0;
        this.currentMonthYear++;
      } else {
        this.currentMonthMonth++;
      }
    },
  },
};
</script>
